import React, { useEffect, useState } from "react";
import "./ParliamentOfMalaysiaHansardPage.css";
import { useParams } from "react-router-dom";
import api from "../../../services/baseUrl";

export default function ParliamentOfMalaysiaHansardPage() {
  const { resourceId } = useParams();
  const [resource, setResource] = useState();
  const navigateToHansard = () => {
    window.open(resource.url, "_blank");
  };

  useEffect(() => {
    const fetchResource = async () => {
      const response = await api.get(`/resource`, {
        params: { id: resourceId },
      });
      setResource(response.data);
    };

    fetchResource();
  }, [resourceId]);
  return (
    <div>
      <div className="hansard-column-container">
        <div className="hansard-column">
          <div className="hansard-column-heading">
            <h2 dangerouslySetInnerHTML={{ __html: resource?.htmlText }}>
              {/* We provide the direct link to the Hansard of the
              <br />
              Parliaments of Malaysia for the usage and reference of the Legal
              Practitioners, Private Companies,
              <br />
              Private Individuals, and the open public with
              <br />
              the most updated Hansard of each
              <br />
              Parliaments seatings. */}
            </h2>
          </div>
          <div className="hansard-column-button">
            <button
              type="button"
              className="hansard-button"
              onClick={() => {
                navigateToHansard();
              }}
            >
              {resource?.second_url ? "in English" : resource?.name}
            </button>
            {resource?.second_url && (
              <>
                <h2 style={{ marginTop: "15px" }}>and here</h2>
                <button
                  type="button"
                  className="pracDirect-button-BM"
                  onClick={() => {
                    window.open(resource.second_url, "_blank");
                  }}
                >
                  in Bahasa Malaysia
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
